import { render, staticRenderFns } from "./AddUnitModal.vue?vue&type=template&id=0bafa786&scoped=true"
import script from "./AddUnitModal.vue?vue&type=script&lang=js"
export * from "./AddUnitModal.vue?vue&type=script&lang=js"
import style0 from "./AddUnitModal.vue?vue&type=style&index=0&id=0bafa786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bafa786",
  null
  
)

export default component.exports